export { default } from './disable-mobile-zoom';
